import { RefObject, useEffect } from 'react';
import debounce from '../utility/debounce';

const useWidthToElement = (ref: RefObject<HTMLElement>, setWidth : (height: number) => void, offset: number = 0) => {
  useEffect(() => {
    const handleResize = debounce(() => {
      if (ref.current) {
        setWidth(0);
        setTimeout(() => {
          if (ref.current) {
            setWidth(ref.current.offsetWidth - offset);
          }
        }, 50);
      }
    }, 200);

    if (ref.current)
      setWidth(ref.current.offsetWidth - offset);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);

  }, [ref.current, setWidth, offset]);
}

export default useWidthToElement;